import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=2826a037"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports